export default __webpack_public_path__ + "a15450d30181d6c2fa7d741518fde1d9.woff2";